import { TranslatedLanguagesCodes } from 'root/src/shared/language/translatedLanguages.fixtures';
import domainName from 'root/src/aws/util/domainName';
export class LanguageService {
    static getCodeFromHost(host) {
        if (!host) {
            return TranslatedLanguagesCodes.En;
        }
        const languageCode = host.split('.').at(0);
        return this.getValidCode(languageCode);
    }
    static getDomainPrefixCode(domain) {
        if (!domain) {
            return TranslatedLanguagesCodes.En;
        }
        const languageCode = domain.split('.').at(0);
        const validCode = this.getValidCode(languageCode);
        // Because en.daredrop and daredrop is the same
        if (validCode === TranslatedLanguagesCodes.En) {
            return null;
        }
        return validCode;
    }
    static getValidCode(languageCode, defaultLanguageCode = TranslatedLanguagesCodes.En) {
        var _a;
        return (_a = Object.values(TranslatedLanguagesCodes).find(code => languageCode === code)) !== null && _a !== void 0 ? _a : defaultLanguageCode;
    }
    static getRedirectUrl(path, languageCode) {
        return `https://${languageCode}.${domainName}${path}`;
    }
}
